import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "p-checkbox__wrapper" }
const _hoisted_2 = { class: "p-checkbox__input" }
const _hoisted_3 = ["checked", "disabled"]
const _hoisted_4 = { class: "p-checkbox__elem" }
const _hoisted_5 = { class: "p-checkbox__label" }
const _hoisted_6 = {
  key: 0,
  class: "p-input__info"
}

import { computed } from 'vue';
import CheckIcon from '@/common/icons/CheckIcon.vue';

interface Props {
  modelValue: boolean,
	valid?: boolean;
	validInfo?: string;
	label?: string;
	disabled?: boolean;
}

// Props

export default /*#__PURE__*/_defineComponent({
  __name: 'pCheckbox',
  props: {
    modelValue: { type: Boolean },
    valid: { type: Boolean, default: true },
    validInfo: {},
    label: {},
    disabled: { type: Boolean }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// Computed
const classes = computed(() => ({
	'p-checkbox_default': true,
	'p-checkbox_disabled': props.disabled,
	'p-checkbox_error': !props.valid,
	'p-checkbox_checked': props.modelValue,
}));

// Emits
const emit = __emit;

// Methods
const onClick = () => {
	if (props.disabled) return;
	emit('update:modelValue', !props.modelValue);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["p-checkbox", classes.value]),
    onClick: _withModifiers(onClick, ["stop","prevent"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("input", {
          checked: _ctx.modelValue,
          type: "checkbox",
          disabled: _ctx.disabled
        }, null, 8 /* PROPS */, _hoisted_3),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(CheckIcon, { class: "p-icon p-icon-checkbox" })
        ])
      ]),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.label), 1 /* TEXT */),
      (!_ctx.valid)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.validInfo), 1 /* TEXT */))
        : _createCommentVNode("v-if", true)
    ])
  ], 2 /* CLASS */))
}
}

})